import { Action, State } from "../../../config/interfaces";

import { initialAction, initialState } from "../../../config";

import {
  USERLOGINFETCH,
  USERLOGINSUCCESS,
  USERLOGINFAILED,
  USERLOGOUT,
  USERLOGININFO,
  LOADACTION,
  TOGGLE_MODAL_PROFILE,
} from "../config";
import { LOADEDACTION, TOGGLE_MODAL_COMPANY, USERUPDATECOMPANY } from "../config/ConstantsAuth";

export function ReducerAuth(
  state: State = initialState,
  action: Action = initialAction
) {
  switch (action.type) {
    case USERLOGINFETCH:
      return {
        ...state,
        fetch: true,
        data: action.data,
        action: action.type,
      };

    case USERLOGINSUCCESS:
      return {
        ...state,
        fetch: false,
        res: action.data,
        action: action.type,
      };

    case USERLOGININFO:
      return {
        ...state,
        fetch: true,
        res: action.data,
        action: action.type,
      };

    case USERLOGINFAILED:
      return {
        ...state,
        fetch: false,
        err: action.data,
        action: action.type,
      };

    case TOGGLE_MODAL_PROFILE:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case TOGGLE_MODAL_COMPANY:
      return {
        ...state,
        isOpenCompany: !state.isOpenCompany,
      };
    case USERUPDATECOMPANY:
      return {
        ...state,
        res: action.data
      };

    case 'SHOW_PRIVACY_POLICY':
      return {
        ...state,
        res: action.data,
        isOpenPrivacyPolicy: true,
        pendingAuth: action.data,
      };

    case 'ACCEPT_PRIVACY_POLICY':
      return {
        ...state,
        isOpenPrivacyPolicy: false,
        pendingAuth: null,
      };

    case USERLOGOUT:
      return initialState;

    default:
      return state;
  }
}

export function ReducerLoader(
  state: any = { isLoading: true, count: 0 },
  action: Action
) {
  switch (action.type) {
    case LOADACTION:
      return { ...state, isLoading: true };
    case LOADEDACTION:
      if (state.count === 1) {
        return { isLoading: false, count: 0 };
      } else {
        return { isLoading: true, count: state.count + 1 };
      }
    default:
      return state;
  }
}
